module.exports = __webpack_public_path__ + "img/logo2.86390039.png";